import { render, staticRenderFns } from "./mainView.vue?vue&type=template&id=63de0a94&scoped=true"
import script from "./mainView.vue?vue&type=script&lang=js"
export * from "./mainView.vue?vue&type=script&lang=js"
import style0 from "./mainView.vue?vue&type=style&index=0&id=63de0a94&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63de0a94",
  null
  
)

export default component.exports